import type { StepInputProps } from './StepInput'

const options = ['Under 10.000 km', '10–20.000 km', '20–30.000 km', '30–40.000 km', 'Over 40.000 km'] as const

export function KmInput({ state, onSubmit }: StepInputProps) {
  return (
    <div className="input-dock">
      <div className="chip-group">
        {options.map((opt) => (
          <button
            key={opt}
            className={`chip-option ${state.kmYear === opt ? 'selected' : ''}`}
            onClick={() => onSubmit({ kmYear: opt })}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  )
}
